<template>
  <v-form ref="formBuscarEmpleado">
    <v-container class="">
      <v-row class="px-3 d-flex align-center justify-center">
        <v-col cols="12" md="8" class="d-flex align-center flex-wrap">
          <label for="identificacion-input" class="font-weight-bold text--secondary mr-4">
            Ingrese el número de identificación
            <span class="colorRojo"> *</span>
          </label>
          <v-text-field
            id="identificacion-input"
            v-model="identificacion"
            :rules="[validacion.required]"
            required
            placeholder="Identificación"
            clearable
            dense
            :disabled="deshabilitaInput"
            @click:clear="limpiarFormulario"
            @input="emitirIdentificacion"
            @blur="validateForm"
            @keypress="soloNumeros"
            @keydown.enter.prevent="emitirSubmit"
            class="flex-grow-1"
          />
        </v-col>

        <v-col
          cols="12"
          md="2"
          class="justify-sm-center justify-md-center d-flex justify-lg-start"
        >
          <slot name="botones"></slot>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
const CODIGO_CARACTER_CERO = 48;
const CODIGO_CARACTER_NUEVE = 57;

export default {
  name: 'FormBuscarEmpleado',

  props: {
    deshabilitaInput: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      identificacion: '',
      validacion: {
        required: value => !!value || 'Este campo es obligatorio',
      },
    };
  },

  methods: {
    emitirIdentificacion() {
      this.$emit('update-identificacion', this.identificacion);
    },

    emitirSubmit() {
      this.$emit('submit-form');
    },

    getIdentificacionInput() {
      return {
        identificacion: this.identificacion,
      };
    },

    limpiarFormulario() {
      this.$refs.formBuscarEmpleado.resetValidation();
      this.$refs.formBuscarEmpleado.reset();
      this.$emit('limpiar-formulario');
    },

    soloNumeros(event) {
      const soloDigitos =
        event.charCode >= CODIGO_CARACTER_CERO &&
        event.charCode <= CODIGO_CARACTER_NUEVE;
      if (!soloDigitos) event.preventDefault();
    },

    validateForm() {
      return this.$refs.formBuscarEmpleado.validate();
    },
  },
};
</script>

<style scoped>
.colorRojo {
  color: red;
}
</style>
